var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAremxyTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9499 0.577634C29.7102 1.48062 28.3404 2.13735 26.8762 2.48873C25.71 0.95705 24.0431 0 22.1978 0C18.6605 0 15.7899 3.53188 15.7899 7.88765C15.7899 8.50633 15.8449 9.10599 15.955 9.68363C10.6275 9.35426 5.90479 6.21782 2.7413 1.43958C2.18903 2.60886 1.87368 3.96535 1.87368 5.40994C1.87368 8.14494 3.00493 10.5596 4.72599 11.9741C3.6765 11.9361 2.68624 11.5777 1.82029 10.9911V11.0872C1.82029 14.9104 4.03023 18.0999 6.96513 18.8217C6.42787 19.0069 5.86058 19.1 5.27577 19.1C4.86281 19.1 4.45987 19.0519 4.06944 18.9598C4.88533 22.0922 7.25128 24.3737 10.0569 24.4348C7.86362 26.5511 5.09807 27.8125 2.09559 27.8125C1.57836 27.8125 1.06696 27.7765 0.566406 27.7044C3.40287 29.9388 6.77408 31.2453 10.3931 31.2453C22.1852 31.2453 28.6315 19.2281 28.6315 8.80366C28.6315 8.46028 28.6265 8.11791 28.6157 7.78154C29.8679 6.66932 30.9557 5.28079 31.8117 3.69906C30.6638 4.32575 29.4274 4.75021 28.131 4.94042C29.4549 3.96535 30.471 2.41965 30.9499 0.577634Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAremxyTwitter);
export default __webpack_public_path__ + "static/media/aremxy_twitter.e75d0508b56c51f843a6bfe2519c53cb.svg";
export { ForwardRef as ReactComponent };